module.exports = __webpack_public_path__ + "static/media/icon_location_select.4cc8d6fc.svg";